import ValueDisplay from 'src/components/ValueDisplay';
import { getMarketPriceDecimals } from 'src/constants/marketDecimalConfig';
import useGetOraclePriceForMarket from 'src/hooks/useGetOraclePriceForMarket';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { BigNum, PRICE_PRECISION_EXP } from '@drift-labs/sdk';

export default function LimitOraclePriceDisplay() {
	const getOraclePriceForMarket = useGetOraclePriceForMarket();
	const selectedMarketId = useDriftStore((s) => s.selectedMarket.current);
	const oracleOffsetString = useDriftStore(
		(s) => s.tradeForm.priceBoxStringValue
	);

	const oraclePriceForMarket = getOraclePriceForMarket(
		selectedMarketId?.marketId
	);

	const oracleOffsetBigNum = BigNum.fromPrint(
		oracleOffsetString,
		PRICE_PRECISION_EXP
	);

	const marketDecimals = getMarketPriceDecimals(
		selectedMarketId?.baseAssetSymbol() ?? ''
	);

	const displayValue = (() => {
		const limitPriceResult = oracleOffsetBigNum.add(
			oraclePriceForMarket ?? BigNum.zero()
		);

		if (limitPriceResult.lt(BigNum.zero())) {
			return '-';
		}

		return limitPriceResult.toNotional(false, undefined, marketDecimals);
	})();

	const oracleOffsetFormatted = oracleOffsetBigNum.toNotional(
		false,
		undefined,
		marketDecimals
	);

	return (
		<ValueDisplay.Default
			label="Price"
			value={displayValue}
			labelTooltip={`Your limit price will be ${oracleOffsetFormatted} from the oracle price.`}
		/>
	);
}
